<template>
  <div v-if="!owner.isUseRowButtons">
    <template v-for="button in owner.defaultRowButtons">
      <template v-if="isDesign">
        <DsfButton
          v-if="showDefaultButtons(button.id)"
          :key="button.id"
          btn-style="icon-text"
          :icon="button.icon"
          :title="button.title"
          style="min-width: auto"
        ></DsfButton>
      </template>
      <template v-else>
        <DsfButton
          v-if="showDefaultButtons(button.id)"
          :class="[button.id + '-button-' + scope.row.$hash]"
          :key="button.id"
          btn-style="icon-text"
          :icon="button.icon"
          :title="button.title"
          style="min-width: auto"
          @click="button.handler(scope)"
        ></DsfButton>
      </template>
    </template>
  </div>
  <div v-else>
    <template v-if="isDesign">
      <DsfButtonBar
        size="small"
        :max-number="owner.rowButtonsMaxNumber"
        :more-button-text="owner.rowButtonsMoreText"
        :more-button-style="owner.rowButtonsMoreStyle"
        :buttons="owner.rowButtons"
        :emit-prefix="'row-button'"
        :local="scope.row"
        class="ds-no-padding operate-column"
        align="center"
      ></DsfButtonBar>
    </template>
    <template v-else>
      <DsfButtonBar
        size="small"
        :render-button="renderRowButton"
        :max-number="owner.rowButtonsMaxNumber"
        :more-button-text="owner.rowButtonsMoreText"
        :more-button-style="owner.rowButtonsMoreStyle"
        :buttons="scope.row.$buttons"
        :emit-prefix="'row-button'"
        :local="scope.row"
        :slot-scope-data="scope"
        class="ds-no-padding operate-column"
        align="center"
      ></DsfButtonBar>
    </template>
  </div>
</template>
<script>
export default {
  name: "DsfSubTableButtons",
  data() {
    return {};
  },
  props: {
    isDesign: {
      type: Boolean,
      default: false
    },
    owner: {
      type: Object,
      default() {
        return null;
      }
    },
    scope: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {},
  updated() {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    showDefaultButtons(id) {
      const { allowEdit, foreverEditor, renderRowButton, $isLeastOne, isUseDialogEdit } =
        this.owner;
      if (this.isDesign) {
        if (id == "edit") {
          return allowEdit && !foreverEditor;
        } else {
          return true;
        }
      } else {
        if (id == "edit") {
          //如果子表强制开启生成一条数据，且当前实际数据只有一条时，编辑按钮隐藏
          if ($isLeastOne) {
            if (isUseDialogEdit) {
              return true;
            } else {
              return false;
            }
          }
          return (
            allowEdit &&
            !foreverEditor &&
            renderRowButton.call(this.owner, id, this.scope.row) !== false
          );
        } else {
          return renderRowButton.call(this.owner, id, this.scope.row) !== false;
        }
      }
    },
    /**
     * 渲染子表按钮
     * button为子表按钮对象
     * result为平台配置子表按钮显示隐藏的结果
     * data为子表当前行数据
     */
    renderRowButton(button, result, data) {
      let showResult = true;
      const { $isLeastOne, allowEdit, foreverEditor, renderRowButton } = this.owner;
      if (renderRowButton === dsf.noop || dsf.isUnDef(renderRowButton)) {
        showResult = result;
      } else {
        showResult = renderRowButton.call(this.owner, button, data) !== false;
      }
      if (button.actionName == "system_subtable_row_edit") {
        if ($isLeastOne) {
          showResult = false;
        } else {
          if (showResult) {
            const showEditButton = allowEdit && !foreverEditor;
            showResult = showEditButton;
          }
        }
      }
      return showResult;
    }
  }
};
</script>